import { render, staticRenderFns } from "./pdp-subscription-interval-selector.vue?vue&type=template&id=5351f613&scoped=true&lang=pug&"
import script from "./pdp-subscription-interval-selector.vue?vue&type=script&lang=coffee&"
export * from "./pdp-subscription-interval-selector.vue?vue&type=script&lang=coffee&"
import style0 from "./pdp-subscription-interval-selector.vue?vue&type=style&index=0&id=5351f613&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5351f613",
  null
  
)

export default component.exports